var site = site || {};
site.Carousel = (function () {
    // Functions
    let carousel = null;

    var copyWithCarousel = function(){
        if(document.getElementsByClassName('js-copy-with-carousel').length){
            const copyWithCarousels = document.querySelectorAll('.js-copy-with-carousel');
            copyWithCarousels.forEach(function(copyWithCarousel, i){
                const prevBtn = copyWithCarousel.previousElementSibling;
                const nextBtn = copyWithCarousel.nextElementSibling;

                let carousel = new Swiper(copyWithCarousel, {
                    slidesPerView: 1.25,
                    slideOffsetAfter: "15px",
                    slideOffsetAfter: "15px",
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                        },
                        992: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                        },
                    },
                })
            })
        }
    }

    var mongerVideosCarousel = function(){
        if(document.getElementsByClassName('js-monger-videos').length){
            const mongerVideosCarousel = document.querySelector('.js-monger-videos');
            const mongerModel = document.querySelector('#mongersModal');
            const findVideoBtn = document.querySelectorAll('.js-find-video');
            let thisVideoId,
                lastSlide = null,
                curSlide = null,
                uto = null,
                rto = null;

            findVideoBtn.forEach(function(btn, i){
                btn.addEventListener('click', function(){
                    thisVideoId = this.getAttribute('data-video-index');                    
                })
            })
            
            $(mongerModel).on('show.bs.modal', function (e) {
                //console.log('show.bs.modal.');
                const prevBtn = mongerVideosCarousel.previousElementSibling;
                const nextBtn = mongerVideosCarousel.nextElementSibling;

                //console.log('thisVideoId: ', thisVideoId);

                curSlide = thisVideoId - 1;

                carousel = new Swiper(mongerVideosCarousel, {
                    init: false,//false here to be able to track the event below
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                    initialSlide: curSlide,
                    autoHeight: true,
                    loop: false,//**WARNING** loop:true has a bug with initial index. it gets back on track after changing slides 
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    }
                })

                carousel.on('init', function (swiper) {
                    //console.log('init', swiper);
                    setTimeout(function(){
                        carousel.update();
                    }, 1000);
                });
                carousel.on('realIndexChange', function (swiper) {//first event triggered for a slide change
                    //console.log('realIndexChange', swiper.realIndex);
                    lastSlide = curSlide;
                    stopVideo(lastSlide);
                });
                carousel.on('transitionStart', function (swiper) {//start adjusting the size here
                    //console.log('transitionStart', swiper.realIndex);
                    curSlide =  swiper.realIndex;
                    resizeSwiper(curSlide);
                });
                carousel.on('transitionEnd', function (swiper) {//last usable event tiggered for a slide change
                    //console.log('transitionEnd', swiper.realIndex);
                    clearTimeout(uto);
                    uto = setTimeout(function(){
                        carousel.update();
                    }, 100);
                });
                carousel.on('update', function (swiper) {//need to call update to trigger swiper resize
                    //console.log('update', swiper);
                });
                carousel.on('resize', function (swiper) {//resize inner elements upon swiper resize
                    clearTimeout(rto);
                    rto = setTimeout(function(){
                        //console.log('resize', swiper);
                        resizeSwiper(curSlide);
                    }, 100);
                });
                carousel.init();
                
            });

            $(mongerModel).on('hidden.bs.modal', function (e) {
                //console.log('hidden.bs.modal. swiper destroy');
                stopVideo(curSlide);
                mongerVideosCarousel.swiper.destroy();
            });

            /**
             * Stop playing video if slide has a video & source
             * @param {*} slideIndex 
            */
            function stopVideo(slideIndex) {
                //console.log('stopVideo.slideIndex:', slideIndex);
                var slide = document.getElementById('slide' + slideIndex),
                    video = slide.getElementsByTagName('video'),
                    source = video[0] ? video[0].getElementsByTagName('source') : null;
                // console.log('video:', video);
                // console.log('source:', source);
                if(video && source) {
                    video[0].pause();
                    video[0].currentTime = 0;
                }
            }

            /**
             * Resize swiper elements based on slide or video width
             * @param {*} slideIndex 
            */
            function resizeSwiper(slideIndex) {
                //console.log('resizeSwiper.slideIndex', slideIndex);
                var slide = document.getElementById('slide' + slideIndex),
                    video = slide.getElementsByTagName('video'),
                    slideWidth = slide.offsetWidth,
                    videoWidth = video[0] ? video[0].offsetWidth : null,
                    useWidth = videoWidth ? videoWidth : slideWidth,
                    swiperWrapper = slide.parentElement,
                    swiper = swiperWrapper.parentElement,
                    modalDialog = swiper.parentElement.parentElement.parentElement;
                //console.log('slideWidth:', slideWidth, 'vs videoWidth:', videoWidth);
                slide.style.maxWidth = useWidth + "px";
                swiperWrapper.style.width = useWidth + "px";
                swiper.style.width = useWidth + "px";
                modalDialog.style.maxWidth = useWidth + "px";
            }

            
        }
    }

    /**
     * Resize carousel from window resize, if exists
    */
    var resizeCarousel = function () {
        if(carousel) {
            //console.log('carousel.resizeCarousel');
            carousel.update();
        }
    }

    // Return
    return {
        copyWithCarousel : copyWithCarousel,
        mongerVideosCarousel : mongerVideosCarousel,
        resizeCarousel : resizeCarousel
    };
}());